import React from 'react';
import type { TocItem } from '../../../types/testDataCharts.types';

interface TocSummaryTableProps {
  tocList: TocItem[];
}

const TocSummaryTable: React.FC<TocSummaryTableProps> = ({ tocList }) => (
  <div className="overflow-x-auto w-full">
    <table className="w-full text-sm border-collapse">
      <thead>
        <tr className="bg-blue-900 text-white">
          <th className="px-3 py-2 text-left font-semibold border border-blue-800 w-2/5">Test Of Change</th>
          <th className="px-3 py-2 text-left font-semibold border border-blue-800 w-2/5">Outcome</th>
          <th className="px-3 py-2 text-left font-semibold border border-blue-800 w-1/5">Rating</th>
        </tr>
      </thead>
      <tbody>
        {tocList.map((item, idx) => (
          <tr
            key={item.testOfChange + idx}
            className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
          >
            <td className="px-3 py-2 border border-gray-200">{item.testOfChangeTitle}</td>
            <td className="px-3 py-2 border border-gray-200">{item.outcome}</td>
            <td className="px-3 py-2 border border-gray-200">{item.rating}-{item.ratingDesc}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default TocSummaryTable;
